export const GROUP_PLAN_SUPPORT_ARTICLE =
  'https://help.smarty.co.uk/en/collections/1974243-group-plans'

export const HELP_LINKS = {
  GROUP_PLAN_SUPPORT_ARTICLE:
    'https://help.smarty.co.uk/en/collections/1974243-group-plans',
  HOW_SWITCHING_WORK:
    'https://help.smarty.co.uk/en/collections/3847384-switching',
  REFER_A_FRIEND_TERMS: 'https://smarty.co.uk/refer-a-friend-terms',
}
